import React from 'react';
import { Workflow } from 'lucide-react';
import { Timer } from './Timer';

interface WorkflowItemProps {
  id: string;
  title: string;
  description: string;
  status: 'scheduled' | 'in_progress' | 'completed' | 'failed';
  isActive: boolean;
  onClick: () => void;
  startTime?: string;
  endTime?: string;
}

export const WorkflowItem: React.FC<WorkflowItemProps> = ({
  title,
  isActive,
  onClick,
  startTime,
  endTime,
}) => {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-8 py-4 hover:bg-accent transition-colors border-b border-zinc-200 ${
        isActive ? 'bg-accent' : ''
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="rounded-md">
            <div className="bg-purple-50 p-1.5 rounded-md">
              <Workflow size={20} className="text-purple-500" />
            </div>
          </div>
          <div>
            <h4 className="text-lg font-medium">{title}</h4>
          </div>
        </div>
        {startTime && <Timer startTime={startTime} endTime={endTime} />}
      </div>
    </button>
  );
};
